// 媒体投放相关接口
import { get, post } from '@/api/base/request';
import { apiPrefix } from '@/api/url';

const {baseApi} = apiPrefix;

// 增转魔方数据统计 - 列表
export const getZxToMofangList = (params) => {
  return post(apiPrefix.baseApi + '/zzx_new/zzdList', params);
}
// 投放业务监控面板 - 列表
export const getLaunchMonitor = (params) => {
  return post(apiPrefix.baseApi + '/marketAccount/launchMonitor', params);
}


// 媒体代理商选项
// export function getAdAgentOptions(params){
//   return get(baseApi + '/marketAccount/adAgent/list', params);
// }
// 库存配置 - 列表
export const getInventoryConfigList = (params) => {
  return post(baseApi + '/zxCode/getInventoryConfigureListNew', params);
}
// 库存配置 - 新增、修改
export const inventoryConfigAddOrUpdate = (params) => {
  if (params.id > 0) return post(baseApi + "/zxCode/modifyInventoryConfigureNew", params, {noValid: true});
  return post(baseApi + "/zxCode/addInventoryConfigureNew", params, {noValid: true});
}
// 库存配置 - 删除
export const inventoryConfigDelete = (params) => {
  return get(baseApi + "/zxCode/deleteInventoryConfigureNew", params);
}
// 库存配置 - 模板下载
export const inventoryConfigExport = (params) => {
  return get(baseApi + "/zxCode/getZxExcel", params, {responseType: "blob"});
}
// 库存配置 - 数据导入
export const inventoryConfigUpload = (params) => {
  const data = new FormData();
  Object.keys(params).forEach((item) => {
    data.append(item, params[item]);
  });

  return post(baseApi + "/zxCode/putZxExcel", data, {
    headers: {"Contennt-Type": "multipart/form-data",},
    noValid: true,
  });
}


// 媒体账户管理 - 媒体平台选项
export function getMediaPlatformOptions(params){
  return get(baseApi + '/market/callback/url', params);
}
// 媒体账户管理 - 列表
export const getMediaAccountList = (params) => {
  return get(baseApi + '/marketAccount/list', params);
}
// 媒体账户管理 - 绑定媒体账户
export function mediaSubAccountUpdate(params){
  return post(baseApi + "/marketAccount/subAccount/edit", params);
}



// 媒体代理商选项
export function getAdAgentOptions(params){
  return get(baseApi + '/marketAccount/adAgent/list', params);
}
// 财务流水 - 列表
export const getFinanceBillList = (params) => {
  return post(baseApi + '/marketAccount/fund/list', params);
}
// 财务流水 - 数据导出
export const financeBillExport = (params) => {
  params.downLoad = 1;
  return post(baseApi + "/marketAccount/fund/list", params, {
    responseType: "blob",
  });
}


// 现金消耗 - 模板下载
export const cashConsumeDownTemplate = (params) => {
  params.downLoad = 1;
  return get(baseApi + "/ffxLaunch/downloadConsumeTemplate", params, {responseType: "blob"});
}
// 现金消耗 - 上传excel表
export const cashConsumeUpload = (params) => {
  const data = new FormData();
  Object.keys(params).forEach((item) => {
    data.append(item, params[item]);
  });

  return post(baseApi + "/marketAccount/cost/upload", data, {
    headers: {"Contennt-Type": "multipart/form-data",},
    noValid: true,
  });
}
